module.exports = __webpack_public_path__ + "static/media/time-square.54aa46bf.svg";